import React, { Fragment, Component } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  FileInput,
  generateFormData,
} from "../../../../../helpers/ui/FileInput";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { withRouter } from "react-router-dom";
import apiResponse from "../../../../../services/apiResponse";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService";
import IndexBloc from "../../Index/Blocs/IndexBloc";
import DetailBloc from "../../IndexUser/Blocs/IndexBloc";
import TableComponent from '../Components/TableComponent';
import MinioClient from "../../../../../services/minioClient";
import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { config } from "../../../../../helpers/config_global";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  if (date) {
    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
  }

  return "-";
};
class UpdateSKModal extends Component {
  indexBloc = new IndexBloc();
  detailBloc = new DetailBloc();
  timer;
  source;
  defaultSize = 10;
  // tambahan
  minioClient = new MinioClient();
  source;
  historyTable = "historydecreetable";
  defaultOrder = "employee_transfer_detail_create_date";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      dataForm: null,
      optionSignatureOfficer: [
        { label: "Kepala Biro Umum", value: "Kepala Biro Umum" },
        { label: "Sekretariat Utama", value: "Sekretariat Utama" },
        { label: "Atas Nama", value: "Atas Nama" },
      ],
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
          filter_value: "",
          page_number: 1,
          page_size: this.defaultSize,
          sort_order: {
            column: this.defaultOrder,
            order: this.defaultSort,
          },
        },
      tokenAPICalled: false,
      // updateSKModal: false,
      // tooltipOpen: false,
    };

  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    var userdata = JSON.parse(localStorage.getItem("userdata"));
    var create_uuid = userdata.employee_uuid;
    this.setState({
      dataForm: {
        create_uuid: create_uuid,
        uuid: this.props.uuid,
        employee_nip: this.props.nip,
        ...values,
      },
      confirm: true,
    });
  };

  submitData = async () => {
    // debugger;
    // console.log("jaka test");
    // console.log(this.state.dataForm);
    const dataForm = generateFormData(this.state.dataForm, "file");
    await this.indexBloc.fetchUpdateSuratKeputusan(dataForm);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        // debugger;
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        this.loadData();
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };
  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      uuid: this.props.uuid,
    };
    await this.detailBloc.fetchHistory(query, this.source.token);
  };

  componentDidMount() {
    this.indexBloc.updateSuratKeputusanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.props.toggle();
          this.props.handleReload();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          this.props.toggle();
          break;
        default:
          break;
      }
    });
    this.detailBloc.historyChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingTable: false,
          });
          break;
        default:
          break;
      }
    });
    this.setTokenAPI();
  }

  componentWillUnmount() {
    this.indexBloc.updateSuratKeputusanChannel?.unsubscribe();
    // this.indexBloc.uploadDecreeChannel?.unsubscribe();
    this.detailBloc.historyChannel?.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    // When modal opens, fetch history immediately
    if (!prevProps.modal && this.props.modal) {
      this.setState({ loadingTable: true }, () => {
        this.setTokenAPI();
      });
    }

    // If the uuid changes while modal is open, reload history
    if (this.props.modal && prevProps.uuid !== this.props.uuid) {
      this.setState({ loadingTable: true }, () => {
        this.setTokenAPI();
      });
    }
  }
  columns = [


    {
      key: "employee_transfer_detail_decree_number",
      text: "Nomor SK",
      sortable: true,
      cell: "-",
    },

    {
      key: "employee_transfer_detail_decree_date",
      text: "Tanggal SK",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_decree_date
          ? reformatDate(record.employee_transfer_detail_decree_date)
          : "-";
      },
    },

    {
      key: "employee_transfer_detail_tmt_date",
      text: "TMT Mulai",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_tmt_date
          ? reformatDate(record.employee_transfer_detail_tmt_date)
          : "-";
      },
    },

    {
      key: "employee_transfer_detail_end_date",
      text: "TMT Berakhir",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_tmt_date_end
          ? reformatDate(record.employee_transfer_detail_tmt_date_end)
          : "-";
      },
    },

    {
      key: "employee_transfer_detail_decree_document_uuid",
      text: "Dokumen SK",
      sortable: true,
      cell: (record) => {
        if (
          record.document_decree?.documents_path == null ||
          record.document_decree?.documents_path == ""
        ) {
          return (
            <label className="badge rounded-pill bg-soft-danger font-size-12">
              Tidak ada Dokumen
            </label>
          );
        } else {
          return (
            <a
              href="javascript:void(0)"
              className="btn btn-success btn-sm"
              onClick={() =>
                this.previewDocument(record.document_decree?.documents_path)
              }
              download
            >
              Download
            </a>
          );
        }
      },
    },

    {
      key: "employee_transfer_detail_create_date",
      text: "Tanggal dibuat",
      sortable: true,
      cell: (record) => {
        return record.employee_transfer_detail_create_date
          ? reformatDate(record.employee_transfer_detail_create_date)
          : "-";
      },
    },
    {
      key: "employee_transfer_detail_log_name",
      text: "Status",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.employee_transfer_detail_log_name ? (
              <label
                className={`badge rounded-pill bg-soft-${record.employee_transfer_detail_log_label} font-size-12`}
              >
                {record.employee_transfer_detail_log_name}
              </label>
            ) : null}
          </Fragment>
        );
      },
    },
  ];
  render() {
    return (
      <Fragment>
        <Modal
          isOpen={this.props.modal}
          size="xl"
          modalClassName="modal-xl"
          toggle={this.props.toggle}
          style={{ maxWidth: "calc(90vw - 20px)" }}
        >
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
          >
            <ModalHeader toggle={this.props.toggle}>
              Update Dokumen Surat Keputusan
            </ModalHeader>
            <ModalBody>
              <Row className="gx-4 gy-4">
                <Col md="7" style={{ minWidth: 320 }}>
                  <div className="border rounded shadow-sm h-100 p-3 bg-white">
                    <div className="d-flex align-items-start justify-content-between mb-3">
                      <div>
                        <h5 className="mb-1">Riwayat Perubahan</h5>
                        {/* <p className="text-muted mb-0">Lihat riwayat upload dan perubahan dokumen SK.</p> */}
                      </div>
                      <hr />
                      <span className="badge bg-info text-white">History</span>
                    </div>
                    <div className="overflow-auto" style={{ maxHeight: 560, minHeight: 360 }}>
                      <MKIDatatable
                        className={this.configDatatable.tableClass}
                        config={this.configDatatable}
                        records={this.state.rows}
                        columns={this.columns}
                        dynamic={true}
                        minWidth={700}
                        total_record={this.state.totalRow}
                        initial={this.state.filter}
                        onChange={(filter) => {
                          this.setState(
                            {
                              loadingTable: true,
                              filter: filter,
                            },
                            function () {
                              this.setTokenAPI();
                            }
                          );
                        }}
                        loading={this.state.loadingTable}
                      />
                    </div>
                  </div>
                </Col>
                <Col md="5">
                  <div className="border rounded shadow-sm h-100 p-3 bg-white">
                    <div className="d-flex align-items-start justify-content-between mb-3">
                      <div>
                        <h5 className="mb-1">Form Update SK</h5>
                        {/* <p className="text-muted mb-0">Perbarui data dan unggah dokumen baru jika diperlukan.</p> */}
                      </div>
                      <hr />
                      <span className="badge bg-primary">Form</span>
                    </div>
                    <dl className="row mb-4 bg-light rounded-3 p-3">
                      <dt className="col-sm-3">NIP</dt>
                      <dd className="col-sm-9">{this.props.nip}</dd>

                      <dt className="col-sm-3">Nama</dt>
                      <dd className="col-sm-9">{this.props.nama}</dd>
                    </dl>
                    <Row className="mb-3 align-items-center">
                      <Label className="col-md-4 col-form-label fw-semibold">
                        Nomor SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="8">
                        <AvField
                          placeholder="Nomor SK"
                          name="employee_transfer_detail_decree_number"
                          type="text"
                          validate={{ required: { value: true } }}
                          value={this.props.employee_transfer_detail_decree_number}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 align-items-center">
                      <Label className="col-md-4 col-form-label fw-semibold">
                        Tanggal SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="8">
                        <AvField
                          placeholder="Tanggal SK"
                          name="employee_transfer_detail_decree_date"
                          type="date"
                          validate={{ required: { value: true } }}
                          value={this.props.employee_transfer_detail_decree_date}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 align-items-center">
                      <Label className="col-md-4 col-form-label fw-semibold">
                        TMT Mulai <span className="text-danger">*</span>
                      </Label>
                      <Col md="8">
                        <AvField
                          placeholder="TMT Mulai"
                          name="employee_transfer_detail_tmt_date"
                          type="date"
                          validate={{
                            required: { value: true },
                            dateValidation: (value) => {
                              const prevDate = this.props.employee_transfer_detail_tmt_date;
                              if (!prevDate || !value) return true;
                              if (new Date(value) <= new Date(prevDate)) {
                                return "Tanggal TMT Mulai tidak boleh sama atau kurang dari tanggal TMT Mulai sebelumnya";
                              }
                              return true;
                            }
                          }}
                          value={this.props.employee_transfer_detail_tmt_date}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 align-items-center">
                      <Label className="col-md-4 col-form-label fw-semibold">
                        TMT Berakhir <span className="text-danger">*</span>
                      </Label>
                      <Col md="8">
                        <AvField
                          placeholder="TMT Berakhir"
                          name="employee_transfer_detail_tmt_date_end"
                          type="date"
                          validate={{
                            required: { value: true },
                            dateValidation: (value, context) => {
                              const tmtMulai = context.employee_transfer_detail_tmt_date;
                              if (!tmtMulai || !value) return true;
                              if (new Date(value) < new Date(tmtMulai)) {
                                return "Tanggal TMT Berakhir tidak boleh kurang dari TMT Mulai";
                              }
                              return true;
                            }
                          }}
                          value={this.props.employee_transfer_detail_tmt_date_end}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 align-items-center">
                      <Label className="col-md-4 col-form-label fw-semibold">
                        Dokumen SK
                      </Label>
                      <Col md="8">
                        <FileInput
                          name="file"
                          placeholder="Dokumen SK"
                          className="form-control"
                          col="6"
                        />
                        {this.props.document_decree != null ? (
                          <div className="mt-2">
                            <a target="_blank" rel="noreferrer" href={this.props.document_decree}>
                              [Lihat Dokumen Sebelumnya]
                            </a>
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.props.toggle}>
                Cancel
              </Button>{" "}
              <Button color="primary" type="submit">
                Submit
              </Button>
            </ModalFooter>
          </AvForm>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default withRouter(UpdateSKModal);
